import {
  Button,
  Col,
  Collapse,
  Input,
  message,
  Radio,
  Row,
  Select,
  Spin,
  Typography,
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FaStarOfLife } from 'react-icons/fa6';
import { productConfigurationSchema } from '../../Utils/Schema';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  createProductConfiguration,
  getLinkedAccount,
  getProductConfiguration,
  getStackHolderAccount,
} from '../../Actions/RazorpaySplittingAction';
import { useDispatch, useSelector } from 'react-redux';

const ProductConfiguration = ({ next, prev, activeKey, markStepComplete }) => {
  const dispatch = useDispatch();

  const {
    restaurant,
    isCreateProductionConfigurationtLoading,
    allLinkedAccountData,
    allStackHolderData,
    allProductConfigurationData,
    isGetLinkedAccountLoading,
    isGetStackHolderAccountLoading,
  } = useSelector((state) => {
    const {
      isCreateProductionConfigurationtLoading,
      allLinkedAccountData,
      allStackHolderData,
      allProductConfigurationData,
      isGetLinkedAccountLoading,
      isGetStackHolderAccountLoading,
    } = state.razorpaySplitting;
    const { restaurant } = state.restaurant;
    return {
      restaurant,
      allStackHolderData,
      allLinkedAccountData,
      allProductConfigurationData,
      isCreateProductionConfigurationtLoading,
      isGetStackHolderAccountLoading,
      isGetLinkedAccountLoading,
    };
  });

  const {
    handleSubmit,
    formState: { errors, isDirty, dirtyFields },
    control,
    reset,
    setValue,
    clearErrors,
  } = useForm({
    resolver: yupResolver(productConfigurationSchema),
  });

  const prevLoadingRef = useRef({
    linked: isGetLinkedAccountLoading,
    stackHolder: isGetStackHolderAccountLoading,
  });

  useEffect(() => {
    const linkedFinished =
      prevLoadingRef.current.linked === true &&
      isGetLinkedAccountLoading === false;
    const stackFinished =
      prevLoadingRef.current.stackHolder === true &&
      isGetStackHolderAccountLoading === false;

    prevLoadingRef.current = {
      linked: isGetLinkedAccountLoading,
      stackHolder: isGetStackHolderAccountLoading,
    };

    if (activeKey === '2') {
      if (
        stackFinished &&
        (allStackHolderData?.items?.length === 0 ||
          !allStackHolderData?.items?.[0]?.id)
      ) {
        message.error('Please create Stack holder account first');
      }

      if (
        linkedFinished &&
        !allLinkedAccountData?.id &&
        !restaurant?.payment_splitting?.linked_account_id
      ) {
        message.error('Please create Linked account first');
      }
    }
  }, [
    activeKey,
    isGetLinkedAccountLoading,
    isGetStackHolderAccountLoading,
    allLinkedAccountData?.id,
    allStackHolderData?.items,
  ]);

  useEffect(() => {
    dispatch(getStackHolderAccount());
    dispatch(getLinkedAccount());
  }, []);

  // useEffect(()=>{
  //     if(activeKey==='1' && !allLinkedAccountData?.id){
  //       message.error('Please create linked account first');
  //     } else if(activeKey==='2' && !allStackHolderData?.items?.[0]?.id){
  //       message.error('Please create Stack holder account');
  //     }
  //   },[activeKey]);

  // useEffect(() => {
  //   if (allProductConfigurationData) {
  //     reset(getInitialFormValues(allProductConfigurationData));
  //   }
  // }, [allProductConfigurationData, reset]);

  useEffect(() => {
    dispatch(getProductConfiguration());
  }, []);

  const [checkedValueActive, setCheckedValueActive] = useState(true);

  const handleCreateProductConfiguration = (data) => {
    const cleanedData = {
      product_configuration: {
        product_name: 'route',
        tnc_accepted: checkedValueActive,
      },
    };
    dispatch(
      createProductConfiguration(
        cleanedData,
        successCreateProductConfiguration,
        failureCreateProductConfiguration
      )
    );
  };

  const successCreateProductConfiguration = () => {
    markStepComplete();
    dispatch(getProductConfiguration());
    setTimeout(() => {
      message.success('Product configuration created successfully');
    }, 1000);
    // next();
  };

  const failureCreateProductConfiguration = (error) => {
    let errorMessage =
      error?.error?.error?.description ||
      error?.error?.description ||
      error?.error?.error ||
      error?.error ||
      error?.message ||
      'Something went wrong.';

    if (typeof errorMessage === 'object') {
      errorMessage = errorMessage.error || JSON.stringify(errorMessage);
    }
    setTimeout(() => {
      message.error(errorMessage);
    }, 1000);
  };

  const onChangeActive = () => {
    setCheckedValueActive(!checkedValueActive);
  };

  return (
    <form onSubmit={handleSubmit(handleCreateProductConfiguration)}>
      <Spin spinning={isCreateProductionConfigurationtLoading}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Typography className='formHeading'>
              Request a product configurations
            </Typography>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Row gutter={[10, 16]}>
                  <Col span={24}>
                    <Typography
                      className='formHeading'
                      style={{ marginBottom: '-15px' }}
                    >
                      Product Name
                      <FaStarOfLife
                        style={{
                          fontSize: '7px',
                          color: '#eb5757',
                          position: 'absolute',
                          top: '7%',
                          marginLeft: '2px',
                        }}
                      />
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Controller
                      name='product_name'
                      control={control}
                      className='inputLabel'
                      defaultValue='route'
                      as={<Input size='large' disabled />}
                    />
                    {errors.product_name && (
                      <p className='errorMessage'>
                        {errors.product_name.message}
                      </p>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row gutter={[10, 16]}>
                  <Col span={16}>
                    <Typography
                      className='formHeading'
                      style={{ marginBottom: '-15px' }}
                    >
                      Do you accept the Terms and Conditions?
                    </Typography>
                  </Col>
                  <Col span={8}>
                    <Controller
                      name='tnc_accepted'
                      control={control}
                      className='inputLabel'
                      render={() => (
                        <Radio.Group
                          onChange={onChangeActive}
                          value={checkedValueActive}
                        >
                          <Radio className='textRadio' value={true}>
                            Yes
                          </Radio>
                          <Radio className='textRadio' value={false}>
                            No
                          </Radio>
                        </Radio.Group>
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Col span={24} style={{ marginTop: '40px' }}>
          <Row gutter={[16, 16]} className='button' justify='center'>
            <Col xl={6} lg={6} md={8} sm={12} xs={12}>
              <Button className='detailsButton' size='large' onClick={prev}>
                Previous
              </Button>
            </Col>
            <Col xl={6} lg={6} md={8} sm={12} xs={12}>
              <Button
                className={
                  !allLinkedAccountData?.id ||
                  !allStackHolderData?.items?.[0]?.id ||
                  allProductConfigurationData?.id
                    ? 'classButton'
                    : 'detailsButton'
                }
                htmlType='submit'
                size='large'
                disabled={
                  !allLinkedAccountData?.id ||
                  !allStackHolderData?.items?.[0]?.id ||
                  allProductConfigurationData?.id
                }
              >
                Create
              </Button>
            </Col>
            <Col xl={6} lg={6} md={8} sm={12} xs={12}>
              <Button size='large' className='detailsButton' onClick={next}>
                Next
              </Button>
            </Col>
          </Row>
        </Col>
      </Spin>
    </form>
  );
};

export default ProductConfiguration;
